module.exports = __webpack_public_path__ + "img/pioti-logo.00b39ec4.png";